import { render, staticRenderFns } from "./BasicSalaryInfo.vue?vue&type=template&id=765d9f3f&scoped=true&"
import script from "./BasicSalaryInfo.vue?vue&type=script&lang=js&"
export * from "./BasicSalaryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d9f3f",
  null
  
)

export default component.exports